import { action, observable } from "mobx";
import { LIST_EPAY_PACKAGES_PACK, SUMMER_PACK_ASSETS } from "../constants/apiUrls/apiUrls";
import callApi from "../utils/callApi";

class SummerPackStore {
  @observable products = [];
  @observable selectedPaymentMethod = null;
  @observable purchased = undefined;
  @observable videoUrl = '';
  @observable magazineUrl = '';
  @observable loading = false;
  @observable modalDismissed = false;

  @action getProduct = () => {
    callApi(LIST_EPAY_PACKAGES_PACK, 'GET', {}, {}, {}, false).then((res) => {
      this.products = res.data.products;
      this.selectedPaymentMethod = res.data.products[0].categories[0].type;
    });
  };

  @action setSelectedPaymentMethod = method => {
    this.selectedPaymentMethod = method;
  }

  @action getAssets = () => {
    this.loading = true;
    callApi(SUMMER_PACK_ASSETS, 'GET', {}, {}, {}, false)
    .then(res => {
      this.purchased = res.data.purchased;
      this.videoUrl = res.data.videoUrl;
      this.magazineUrl = res.data.magazineUrl;
      this.loading = false;
    })
  }

  @action dismissModalInSession = () => {
    this.modalDismissed = true;
  }
}

export default new SummerPackStore();
